import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { DateMomentPipe } from 'libraries/date/dateMoment.pipe';
import { ITicketDate, sourceTicketBooking } from 'libraries/service/resources/booking/interfaces/IGetBookings';

@Component({
    selector: 'travel-date-begin-end',
    template: `
        <div class="dates">
            <div *ngIf="dates.begin">
                {{ labels.departure }}
                <span class="date" [class.booking-source]="beginDateBookingSource">{{ dates.begin }}</span>
            </div>

            <div *ngIf="dates.end">
                {{ labels.arrival }}
                <span class="date" [class.booking-source]="endDateBookingSource">{{ dates.end }}</span>
            </div>
        </div>
    `,
    styles: [`
        .dates {
            display: flex;
            flex-direction: column;
            padding-left: .75rem;
        }

        .date {
            font-weight: bold;
        }

        .booking-source {
            font-style: italic;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TravelDateBeginEndComponent implements OnInit {
    @Input()
    public begin: ITicketDate;
    @Input()
    public end: ITicketDate;

    public labels: ILabels = {
        departure: Yii.t('wui-shared-js', 'Départ le'),
        arrival: Yii.t('wui-shared-js', 'Arrivée le'),
        at: Yii.t('wui-shared-js', 'à'),
    };

    public beginDateBookingSource: boolean;
    public endDateBookingSource: boolean;
    public dates: {
        begin: string;
        end: string;
    };

    public dateFormat: string = `ddd DD MMM YYYY ${this.labels.at} HH:mm`;

    constructor(
        private readonly dateMomentPipe: DateMomentPipe
    ) {}

    public ngOnInit(): void {
        this.beginDateBookingSource = Boolean(this.begin && this.begin.source && this.begin.source === sourceTicketBooking);
        this.endDateBookingSource = Boolean(this.end && this.end.source && this.end.source === sourceTicketBooking);

        this.dates = {
            begin: this.begin ? this.dateMomentPipe.transform(this.begin.value, this.dateFormat): null,
            end: this.end ? this.dateMomentPipe.transform(this.end.value, this.dateFormat): null,
        };
    }
}